export default function isoString(date) {
  return new Date(date).toISOString()
}
